import { useState, useEffect } from "react";
import styled from "styled-components";
import { searchPublishers } from "../../services/PublisherService";
import { Container, Input, Dropdown, DropdownItem } from "../CommonComponents/DataCard";
import Button from "../CommonComponents/Button";

const SelectedPublisherDiv = styled.div`
  background: ${({ theme }) => theme.colors.lineColor}33;
  color: ${({ theme }) => theme.colors.text};
  border-radius: 4px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
`;

export default function PublisherSelector({ selectedPublisher, setSelectedPublisher, setShowPublisherModal }) {
    const [query, setQuery] = useState("");
    const [publishers, setPublishers] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (query.length < 2) {
            setPublishers([]);
            return;
        }

        const handler = setTimeout(async () => {
            setLoading(true);
            try {
                const results = await searchPublishers(query);
                setPublishers(results);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }, 300);

        return () => clearTimeout(handler);
    }, [query]);

    const handleSelect = (publisher) => {
        setSelectedPublisher(publisher); // samo jedan objekt
        setQuery("");
        setPublishers([]);
    };

    const handleRemove = () => {
        setSelectedPublisher(null);
    };

    return (
        <Container style={{ position: "relative" }}>
            <div style={{ display: "flex", gap: "8px", marginBottom: "1rem", alignItems: "center" }}>
                <Input
                    value={query}
                    placeholder="Pretraži izdavače..."
                    onChange={(e) => setQuery(e.target.value)}
                    style={{ marginBottom: "0px" }}
                />
                <Button
                    tekst={"+"}
                    akcija={() => setShowPublisherModal(true)}
                />
            </div>

            {publishers.length > 0 && (
                <Dropdown>
                    {publishers.map((publisher) => (
                        <DropdownItem key={publisher.id} onClick={() => handleSelect(publisher)}>
                            {publisher.name}
                        </DropdownItem>
                    ))}
                </Dropdown>
            )}

            <h4>Odabrani izdavač:</h4>
            {selectedPublisher && (
                <SelectedPublisherDiv>
                    {selectedPublisher.name}
                    <button onClick={handleRemove}>✖</button>
                </SelectedPublisherDiv>
            )}
        </Container>
    );
}
